module.exports = __webpack_public_path__ + "static/media/employeeinout_1.12e8639a.png";